import React from "react";
import {
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
} from "recharts";

// Sample data
const data = [
  { date: "Nov 01", regDown: 150, regUp: 200, spinning: 100, energy: 250, cumulative: 500 },
  { date: "Nov 03", regDown: 180, regUp: 220, spinning: 120, energy: 300, cumulative: 820 },
  { date: "Nov 05", regDown: 200, regUp: 240, spinning: 130, energy: 350, cumulative: 1200 },
  { date: "Nov 07", regDown: 170, regUp: 210, spinning: 110, energy: 280, cumulative: 1490 },
  { date: "Nov 09", regDown: 90, regUp: 90, spinning: 90, energy: 90, cumulative: 90 },
  { date: "Nov 11", regDown: 160, regUp: 220, spinning: 130, energy: 310, cumulative: 2200 },
];

// Custom legend rendering
const renderLegend = (props: any) => {
  const { payload } = props;
  return (
    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", marginBottom: "15px" }}>
      <span style={{ marginRight: "10px", fontWeight: "bold", fontSize: "12px" }}>Product :</span>
      {payload.map((entry: any, index: number) => (
        <div key={`item-${index}`} style={{ display: "flex", alignItems: "center", marginRight: "15px" }}>
          <span
            style={{
              display: "inline-block",
              width: "10px",
              height: "10px",
              backgroundColor: entry.color,
              borderRadius: "50%",
              marginRight: "5px",
            }}
          ></span>
          <span style={{ fontSize: "12px", color: "#666" }}>{entry.value}</span>
        </div>
      ))}
    </div>
  );
};

const ChartComponent: React.FC = () => {
  return (
    <div style={{ width: "100%", height: "400px" }}>
      <ResponsiveContainer width="100%" height={400}>
        <ComposedChart data={data} margin={{ top: 50, right: 20, bottom: 50, left: 20 }}>
          <CartesianGrid stroke="#f5f5f5" />
          
          {/* Legend with margin */}
          <Legend 
            content={renderLegend} 
            verticalAlign="top" 
            align="center" 
            style={{ marginBottom: "20px" }} // Added bottom margin to create space
          />
          
          <Bar yAxisId="left" dataKey="regDown" stackId="a" fill="#FABE7A" name="A/S Regulation Down" barSize={75} />
          <Bar yAxisId="left" dataKey="regUp" stackId="a" fill="#8A6CE3" name="A/S Regulation Up" barSize={75} />
          <Bar yAxisId="left" dataKey="spinning" stackId="a" fill="#59E6F6" name="A/S Spinning" barSize={75} />
          <Bar yAxisId="left" dataKey="energy" stackId="a" fill="#F6866A" name="Energy" barSize={75} />
        
          <Line
            yAxisId="right"
            type="linear"
            dataKey="cumulative"
            stroke="#7661E2"
            strokeWidth={4}
            dot={false}
            name="Meter MWh"
            connectNulls={true}
            activeDot={{ r: 0 }}
          />
        
          {/* X Axis */}
          <XAxis
            dataKey="date"
            tick={{ fontSize: 12 }}
            padding={{ left: 20, right: 20 }}
            label={{
              value: "Date",
              position: "insideBottom",
              offset: -10,
              fontSize: 14,
              fontWeight: "bold",
            }}
          />
          
          {/* Left Y Axis */}
          <YAxis
            yAxisId="left"
            tickFormatter={(value) => `${value}`}
            tick={{ fontSize: 12 }}
            axisLine={false}
            tickLine={false}
            label={{
              value: "Generation & Awards MWh",
              angle: -90,
              position: "insideLeft",
              fontSize: 14,
              fontWeight: "bold",
              dx: -10,
              dy: 90,
            }}
          />
          
          {/* Right Y Axis */}
          <YAxis
            yAxisId="right"
            orientation="right"
            tickFormatter={(value) => `${value / 1000}k`}
            tick={{ fontSize: 12 }}
            axisLine={false}
            tickLine={false}
            domain={[0, 'dataMax']}
            label={{
              value: "Meter MWh",
              angle: -90,
              position: "insideRight",
              fontSize: 14,
              fontWeight: "bold",
            }}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ChartComponent;
